import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Icon } from 'components/Icon/Icon';

import { ReactComponent as CheckIcon } from 'assets/glyphs/check-circle-16.svg';

import { HeaderItemType } from './types';

export interface WizardItemCircleProps {
    index: number;
    type: HeaderItemType;
}

const getCircleBackgroundColor = (theme: Theme, type: HeaderItemType) => {
    switch (type) {
        case HeaderItemType.ACTIVE:
            return theme.palette.commercialOffer.main;
        case HeaderItemType.DISABLED:
            return theme.palette.brandPrimary.light;
    }
};

const useStyles = makeStyles(theme => ({
    circle: {
        backgroundColor: (props: WizardItemCircleProps) => getCircleBackgroundColor(theme, props.type),
        borderRadius: 16,
        color: theme.palette.fixedWhite.primary,
        height: 32,
        width: 32,
        lineHeight: '32px',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: 14,
        margin: '0 auto',
    },
}));

export const HeaderItemCircle: FC<WizardItemCircleProps> = props => {
    const classes = useStyles(props);
    const isComplete = props.type === HeaderItemType.COMPLETE;

    return isComplete ? (
        <div style={{ color: '#243143' }}>
            <Icon component={CheckIcon} size={32} svgSize={32} />
        </div>
    ) : (
        <div className={classes.circle}>{props.index}</div>
    );
};
